import { useState } from 'react';
import { employeeApi } from '../../lib/api';
import { pushSupported, pushPermission, subscribeToPush } from '../../lib/push';
import { todayStr } from '../../lib/format';
import { errorMessage } from '../../components/ErrorModalBody';

const DISMISS_KEY = 'coala.notifDismissDate';

/** Verifica (a cada carregamento, mas no máximo cobra atenção 1x por dia)
 * se o funcionário já ativou notificações e, se não, salienta a importância
 * logo de cara — em vez de só um card discreto em "Minha conta". */
export function NotificationNudge() {
  const [status, setStatus] = useState(() => pushPermission());
  const [dismissed, setDismissed] = useState(() => localStorage.getItem(DISMISS_KEY) === todayStr());
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  if (!pushSupported() || status === 'granted' || dismissed) return null;

  async function ativar() {
    setBusy(true);
    setError('');
    try {
      const sub = await subscribeToPush();
      await employeeApi.savePushSubscription(sub);
      setStatus('granted');
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  }

  function agoraNao() {
    localStorage.setItem(DISMISS_KEY, todayStr());
    setDismissed(true);
  }

  return (
    <div className="banner" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
      <div>
        <b>📣 Ative as notificações!</b> É assim que o gestor consegue te avisar rapidinho sobre pendências e informações importantes do evento.
        {error && <div className="err">{error}</div>}
      </div>
      <div style={{ display: 'flex', gap: 8, flex: 'none' }}>
        <button className="btn btn-primary btn-sm" disabled={busy} onClick={ativar}>Ativar agora</button>
        <button className="btn btn-ghost btn-sm" onClick={agoraNao}>Agora não</button>
      </div>
    </div>
  );
}
